export default "__VITE_ASSET__741795b5__"